import { useCallback, useEffect, useState } from 'react';
import { invalidateNodeCatalog, loadNodeCatalog } from './nodeCatalogCache';

const EMPTY_CATALOG = { isActive: false, nodes: [], charts: [], filters: [] };

// Реэкспорт: потребители (LlmNodesTab) исторически импортируют инвалидацию отсюда.
export { invalidateNodeCatalog };

const useNodeCatalog = () => {
  const [catalog, setCatalog] = useState(EMPTY_CATALOG);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [attempt, setAttempt] = useState(0);

  // Ошибку каталога раньше нечем было показать: секция графиков просто исчезала со
  // страницы, и «сервер недоступен» выглядело так же, как «пакет не загружен».
  const reload = useCallback(() => {
    invalidateNodeCatalog();
    setAttempt((current) => current + 1);
  }, []);

  useEffect(() => {
    let cancelled = false;

    setIsLoading(true);

    loadNodeCatalog()
      .then((result) => {
        if (!cancelled) {
          setCatalog(result ?? EMPTY_CATALOG);
          setError(null);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setCatalog(EMPTY_CATALOG);
          setError('Не удалось загрузить каталог узлов анализа.');
        }
      })
      .finally(() => {
        if (!cancelled) {
          setIsLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [attempt]);

  return { catalog, isLoading, error, reload, isActive: catalog.isActive === true };
};

export default useNodeCatalog;
